module.exports = __webpack_public_path__ + "img/news.581b3774.png";